// extracted by mini-css-extract-plugin
export default {"disabled":"StepIcon_disabled__apGt9"};